import { render, staticRenderFns } from "./EditPieceModal.vue?vue&type=template&id=06fcc3e9&"
import script from "./EditPieceModal.vue?vue&type=script&lang=js&"
export * from "./EditPieceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports